<template>
<header class="app-header navbar fixed-top">
	<div class="container-fluid">
		<button class="navbar-toggler sidebar-toggler d-lg-none mr-auto" type="button" data-toggle="sidebar-show">
			<span class="navbar-toggler-icon"></span>
		</button>
		<button class="navbar-toggler d-md-down-none sidebar-toggler" type="button" data-toggle="sidebar-lg-show">
			<span class="navbar-toggler-icon"></span>
		</button>

		<router-link to="/" class="navbar-brand">cp.legalbis.ru</router-link>

		<div class="navbar-end navbar-nav ml-auto">
			<!--
			<div class="navbar-search">
				<search></search>
			</div>
			-->
			<ul class="nav navbar-nav">
				<li class="nav-item dropdown mr-4">
					<a class="nav-link" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="false">
						<i class="icon-bell"></i>
						<span class="badge badge-pill badge-danger" v-if="$store.state.notification.totalNumber > 0">{{ $store.state.notification.totalNumber }}</span>
					</a>
					<div class="dropdown-menu dropdown-menu-right dropdown-menu-lg notification-dropdown">
						<div class="dropdown-header text-center">
							<strong>Новых уведомлений: {{ $store.state.notification.totalNumber }}</strong>
						</div>
						<div class="dropdown-item text-center no-result" v-if="$store.state.notification.totalNumber === 0">Нет уведомлений</div>
						<div v-if="$store.state.notification.notifications.length > 0">
							<vue-custom-scrollbar
								class="scroll-area"
								:settings="scrollSettings"
							>
								<router-link :to="'/notifications/' + notification.id" class="dropdown-item" v-for="(notification, key) in $store.state.notification.notifications" :key="key">
									<div>
										<small class="text-muted">{{ getUsername(notification.user_id) }}</small>
										<small class="text-muted float-right mt-1">{{ dateFormatter(notification.created_at) }}</small>
									</div>
									<div class="text-truncate font-weight-bold">{{ notification.title }}</div>
									<div class="small text-muted text-truncate" v-html="textPrepare(notification.text)"></div>
								</router-link>
							</vue-custom-scrollbar>
						</div>
						<div class="dropdown-footer text-center">
							<router-link to="/notifications">Все уведомления</router-link>
						</div>
					</div>
				</li>
				<!--
				<div class="timeman mr-4">
					<a href="#" v-if="$store.state.user.at_work === 0" class="timeman__start bg-green image-round" @click.prevent="onChangeStatus"><i class="icon-power icons font-2xl d-block"></i></a>
					<a href="#" v-if="$store.state.user.at_work === 1" class="timeman__stop bg-light image-round" @click.prevent="onChangeStatus"><i class="icon-power icons font-2xl d-block"></i></a>
				</div>
				-->
				<li class="nav-item dropdown">
					<a class="nav-link nav-link profile-photo__image" data-toggle="dropdown" href="#" role="button" aria-haspopup="true" aria-expanded="true">
						<img v-if="$store.state.user.photo !== null" :src="$store.state.user.photo.xs" class="image-round" />
						<div v-if="$store.state.user.photo === null" v-bind:style="{backgroundColor: defaultProfilePhotoColor}" class="image-round profile-photo-default"><span>{{ defaultProfilePhotoString }}</span></div>
					</a>
					<div class="dropdown-menu dropdown-menu-right">
						<div class="dropdown-header text-center">
						<strong>Аккаунт</strong>
						</div>
						<router-link :to="'/users/' + $store.state.user.id" class="dropdown-item"><i class="fa fa-user"></i> Мой профиль</router-link>
						<a class="dropdown-item" href="#" @click="logout()"><i class="fa fa-lock"></i> Выйти</a>
					</div>
				</li>
				</ul>
			</div>
		</div>
	</header>
</template>

<script>
import moment from 'moment'
import vueCustomScrollbar from 'vue-custom-scrollbar'
import 'bootstrap/js/dist/dropdown.js'
import stringtohexcolor from '@bezlepkin/stringtohexcolor'
import user from '@/user'
import userAtworkHTTP from '@/api/modules/user/atwork'
import search from '@/components/search/navbar-search'
export default {
	name: 'Header',
	components: {
		vueCustomScrollbar,
		search
	},
	data: function () {
		return {
			isShow: true,
			isGuest: true,
			status: false,
			dropdown: '',
			defaultProfilePhotoString: '',
			defaultProfilePhotoColor: '',
			currTime: '',
			scrollSettings: {
				maxScrollbarLength: 60
			}
		}
	},
	created () {
		this.createDefaultProfilePhoto()
		moment.locale('ru')
		this.currTime = moment().format('HH:mm')
		setInterval(() => this.updateCurrentTime(), 1 * 1000)
	},
	mounted: function () {
		var self = this
		this.isGuest = user.isGuest()
		if (this.$route.meta.layout === 'empty') {
			this.isShow = false
		}
		document.addEventListener('click', function (event) {
			if (event.target.closest('.user-dropdown-menu__trigger') === null) {
				self.dropdown = ''
			}
		})
	},
	methods: {
		logout: function () {
			console.log('logout')
			this.$socket.disconnect()
			user.logout()
		},
		userDropdownMenu: function (event) {
			event.preventDefault()
			this.toggleUserDropdownMenu()
		},
		toggleUserDropdownMenu: function () {
			this.dropdown = (this.dropdown === '') ? 'open' : ''
		},
		createDefaultProfilePhoto () {
			const color = stringtohexcolor(this.$store.state.user.first_name + ' ' + this.$store.state.user.last_name)
			this.defaultProfilePhotoColor = '#' + color.color
			this.defaultProfilePhotoString = color.string
		},
		onChangeStatus () {
			let atWorkStatus = 1
			if (this.$store.state.user.at_work === 1) atWorkStatus = 0
			userAtworkHTTP.create(atWorkStatus).then((result) => {
				user.update()
			})
		},
		getUsername (id) {
			if (Object.keys(this.$store.state.userModule.users).length === 0) return ''
			const user = this.$store.state.userModule.users[id]
			return user.first_name + ' ' + user.last_name
		},
		dateFormatter (date) {
			date = moment(date).format('YYYY-MM-DD')
			moment.locale('ru')
			// если сегодня
			let currYear = moment().format('YYYY')
			if (date === moment().format('YYYY-MM-DD')) return 'Сегодня'
			// если текущий год/не текущий год
			if (currYear === moment().format('YYYY')) {
				return moment(date).format('D MMMM')
			} else {
				return moment(date).format('D MMMM, YYYY')
			}
		},
		textPrepare (text) {
			let urlRegex = /(https?:\/\/[^\s]+)/g
			var linkTagRegex = /<a(.*?)<\/a>/g
			text = text.replace(linkTagRegex, (link) => {
				link = link.replace(urlRegex, (url) => {
					let _url = url.split('"')[0].replace('cp.legalbis.ru/api', 'cp.legalbis.ru/#')
					return '<a href="' + _url + '" target="_blank">' + _url + '</a>'
				})
				return link.replace('<a href="', '')
			})
			return '<strong>' + text + '</strong>'
		},
		updateCurrentTime () {
			this.currTime = moment().format('HH:mm')
		},
		toggleStatus () {
			this.status = !this.status
		}
	}
}
</script>
<style lang="scss">
.app-header {
	box-shadow: 0px 0px 4px rgba(0,0,0,0.1) !important;
	.navbar-search {
	position: absolute;
	bottom: 0;
	right: 0;
	margin-bottom: -50px;
	padding: 7px 15px 7px 7px;
	background: #fff;
	border-bottom: 1px solid #c8ced3;
	border-left: 1px solid #c8ced3;
	border-bottom-left-radius: 0.25rem;
	box-shadow: 0px 4px 4px rgba(0,0,0,0.1) !important;
	}
}
.profile-photo__image {
	width: 40px;
	height: 40px;
	img {
		width: 100%;
		height: auto;
	}
}
.profile-photo-default {
	display: -webkit-box;
	display: -webkit-flex;
	display: -ms-flexbox;
	display: flex;
	-webkit-box-align: center;
	-webkit-align-items: center;
	-ms-flex-align: center;
	align-items: center;
	-webkit-box-pack: center;
	-webkit-justify-content: center;
	-ms-flex-pack: center;
	justify-content: center;
	width: 100%;
	height: 100%;
	color: #fff;
	text-transform: uppercase;
	font-size: 1.3em;
}

.timeman {
	a {
		width: 40px;
		height: 40px;
		display: flex;
		align-items: center;
		color: #fff;
    font-weight: 100;
		text-decoration: none;
		text-transform: uppercase;
		-webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
    -webkit-box-pack: center;
    -ms-flex-pack: center;
    justify-content: center;
		&:focus, &:active, &:hover {
			text-decoration: none;
		}
	}
	.timeman__time {
		width: 70px;
		margin: 0;
		font-weight: 300;
	}
	.timeman__stop {
		color: #73818f;
	}
}
</style>



// WEBPACK FOOTER //
// src/views/layouts/header.vue